import { useCallback } from "react"
import { Block, useStyletron } from "@mezo-org/mezo-clay"

import { setOnboardingFlow, setOpenModal, useDappDispatch } from "#/redux-state"
import { usePosthogSignUpEvent } from "#/shared/hooks/posthog-events"
import { Flow, OnboardingFlow } from "#/shared/types"

import OnboardingModalContent from "./OnboardingModalContent"
import OnboardingModalFlowButton from "./OnboardingModalFlowButton"
import OnboardingModalFooter from "./OnboardingModalFooter"
import OnboardingModalSignInHeader from "./OnboardingModalSignInHeader"

export default function OnboardingModalAuthentication() {
  const dispatch = useDappDispatch()
  const [css, theme] = useStyletron()
  const { emitSignUpStartedEvent } = usePosthogSignUpEvent()

  const signInWithWalletHandler = useCallback(() => {
    emitSignUpStartedEvent()
    dispatch(setOnboardingFlow(OnboardingFlow.SIGN_IN))
    dispatch(setOpenModal("wallet-connect"))
  }, [dispatch, emitSignUpStartedEvent])

  return (
    <OnboardingModalContent footer={<OnboardingModalFooter />}>
      <Block className={css({ paddingTop: theme.sizing.scale1000 })}>
        <OnboardingModalSignInHeader />
        <Block
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: theme.sizing.scale600,
          })}
        >
          <OnboardingModalFlowButton
            onClick={signInWithWalletHandler}
            flow={Flow.ETHEREUM}
          />
          <OnboardingModalFlowButton
            onClick={signInWithWalletHandler}
            flow={Flow.BITCOIN}
          />
        </Block>
      </Block>
    </OnboardingModalContent>
  )
}
